import { Suspense, lazy } from 'react';

import { useSplashScreenStore } from '@/widgets/RootLayout';

import { PageLoader } from '@/shared/ui';

const CustomizeAsync = lazy(() => import('./ui/Customize'));

export const Customize = () => {
  const isShowSplashScreen = useSplashScreenStore(
    (state) => state.isShowSplashScreen,
  );
  if (isShowSplashScreen) return null;
  return (
    <Suspense fallback={<PageLoader />}>
      <CustomizeAsync />
    </Suspense>
  );
};
